import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalProcessPaymentError extends StripeTerminalError {
  constructor(message: unknown) {
    super(message);
    this.name = 'StripeTerminalProcessPaymentError';
  }
}
